module.exports = __webpack_public_path__ + "media/images/logo-white-2ea21e253359154fd6e5a29125421545.png";